import BudgetClient from '@/api/Budget/budget.client';

const client = new BudgetClient();

export default {
  namespaced: true,
  state: () => ({
    isLoading: false,
    isSaving: false,
    budgets: [],
    budgetAtual: null,
    supervisores: [],
    representantes: [],
    filters: {},
    dashboard: null,
    meuSaldo: null,
    meusPedidos: null,
  }),
  getters: {
    budgets: state => state.budgets,
    budgetAtual: state => state.budgetAtual,
    supervisores: state => state.supervisores,
    representantes: state => state.representantes,
    isLoading: state => state.isLoading,
    isSaving: state => state.isSaving,
    dashboard: state => state.dashboard,
    meuSaldo: state => state.meuSaldo,
    meusPedidos: state => state.meusPedidos,
  },
  mutations: {
    SET_LOADING(state, v) { state.isLoading = v; },
    SET_SAVING(state, v) { state.isSaving = v; },
    SET_BUDGETS(state, v) { state.budgets = v; },
    SET_BUDGET_ATUAL(state, v) { state.budgetAtual = v; },
    SET_SUPERVISORES(state, v) { state.supervisores = v; },
    SET_REPRESENTANTES(state, v) { state.representantes = v; },
    SET_FILTERS(state, v) { state.filters = v; },
    SET_DASHBOARD(state, v) { state.dashboard = v; },
    SET_MEU_SALDO(state, v) { state.meuSaldo = v; },
    SET_MEUS_PEDIDOS(state, v) { state.meusPedidos = v; },
  },
  actions: {
    async listar({ commit, state }) {
      commit('SET_LOADING', true);
      try {
        const { data: res } = await client.listar({ ...state.filters });
        commit('SET_BUDGETS', res.data || []);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async buscarPorId({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const { data: res } = await client.buscarPorId(id);
        commit('SET_BUDGET_ATUAL', res.data || null);
        return res.data;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async criar({ commit, dispatch }, payload) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.criar(payload);
        await dispatch('listar');
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async atualizar({ commit, dispatch }, { id, payload }) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.atualizar(id, payload);
        await dispatch('listar');
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async excluir({ dispatch }, id) {
      await client.excluir(id);
      await dispatch('listar');
    },
    async carregarSupervisores({ commit }) {
      const { data: res } = await client.listarSupervisores();
      commit('SET_SUPERVISORES', res.data || []);
      return res.data;
    },
    async carregarRepresentantes({ commit }, supervisorid) {
      if (!supervisorid) { commit('SET_REPRESENTANTES', []); return []; }
      const { data: res } = await client.listarRepresentantes(supervisorid);
      commit('SET_REPRESENTANTES', res.data || []);
      return res.data;
    },
    async ajusteManual({ commit }, { id, payload }) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.ajusteManual(id, payload);
        commit('SET_BUDGET_ATUAL', res.data || null);
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async transferir({ commit }, { id, payload }) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.transferir(id, payload);
        commit('SET_BUDGET_ATUAL', res.data || null);
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async salvarAlocacoes({ commit }, { id, payload }) {
      commit('SET_SAVING', true);
      try {
        const { data: res } = await client.salvarAlocacoes(id, payload);
        commit('SET_BUDGET_ATUAL', res.data || null);
        return res.data;
      } finally {
        commit('SET_SAVING', false);
      }
    },
    async carregarDashboard({ commit }) {
      commit('SET_LOADING', true);
      try {
        const { data: res } = await client.dashboard();
        commit('SET_DASHBOARD', res.data || null);
        return res.data;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async carregarMeuSaldo({ commit }) {
      try {
        const { data: res } = await client.meuSaldo();
        commit('SET_MEU_SALDO', res.data || null);
        return res.data;
      } catch (err) {
        commit('SET_MEU_SALDO', null);
        return null;
      }
    },
    async carregarMeusPedidos({ commit }) {
      try {
        const { data: res } = await client.meusPedidos();
        commit('SET_MEUS_PEDIDOS', res.data || null);
        return res.data;
      } catch (err) {
        commit('SET_MEUS_PEDIDOS', null);
        return null;
      }
    },
    setFilters({ commit }, filters) { commit('SET_FILTERS', filters); },
  },
};
